function Component404() {
  return (
    <div className='Component404'>
      <div className="page-404 flex justify-center items-center flex-col">
        <h1 className="text-[150px] font-semibold">404</h1>
        <h3 className="text-[50px] font-semibold">Not Found</h3>
      </div>
    </div>
  );
}

export default Component404;
